// 导入组件
import topTabs from './src/top-tabs.vue'

// 为组件提供 install 安装方法，供按需引入
topTabs.install = function (Vue) {
  Vue.component(topTabs.name, topTabs)
}

// 默认导出组件
export default topTabs
